module.exports = __webpack_public_path__ + "img/bingx.a9615f58.png";